module.exports = __webpack_public_path__ + "img/custmoer.a466a7ec.png";